<template>
  <div class="header" :class="{'header-area':selectArea.isSelectArea || userInfo.level == 2}">
    <div class="selects">
      <div class="fl selects-area" @click="changeModel(1)">
        <SelectArea :defaultValue="selectArea.selectAreaName"> </SelectArea>
      </div>
      <div class="fr  selects-date" @click="changeModel(2)">
        <selectDate :value='showSelectDateValue'></selectDate>
      </div>
      <div class="clearfix"></div>
    </div>
    <div class="all">
      <img v-if="!isStar" @click="collectFn" class="stars" src="../../../assets/app/star.png">
      <img v-if="isStar" @click="collectFn" class="stars" src="../../../assets/app/starYellow.png">
      <div class="all-item-01">
        <font class="number" v-text="data.family"></font>
        <font class="desc">（{{data.unit}}）</font>
      </div>
      <div @click="showPopup(1)" class="all-item-02">
        <font class="mouth">口径</font>
        <img class="question" src="../../../assets/app/question.png" alt="口径">
        <Popup @hide="hidePop" v-if="popObjMouth.visable" :obj="popObjMouth"></Popup>
      </div>
    </div>
    <div class="rates">
      <div class="items">
        <div class="item">{{data.thanTitle}}</div>
        <div class="item item-rate" :class="{'item-rate-active': Number(data.lastMonth) >= 0}">
          <img v-if="Number(data.lastMonth) < 0" class="item-img" src="../../../assets/app/down.png" alt="">
          <img v-if="Number(data.lastMonth) >= 0" class="item-img" src="../../../assets/app/up.png" alt=""> {{data.lastMonth + "%"}}</div>
      </div>
      <div class="items">
        <div class="item">{{data.thanTitle2}}</div>
        <div class="item item-rate " :class="{'item-rate-active':Number(data.lastYear) >= 0}">
          <img v-if="Number(data.lastYear) < 0" class="item-img" src="../../../assets/app/down.png" alt="">
          <img v-if="Number(data.lastYear) >= 0" class="item-img" src="../../../assets/app/up.png" alt=""> {{data.lastYear + "%"}}</div>
      </div>
    </div>
    <div v-show='!selectArea.isSelectArea && userInfo.level < 2' @click="showPopup(2)" class="header-bottom">
      <div class="header-line"></div>
      <div class="goods">
        <div class="items">
          <div class="item item-name">{{data.bestTitle}}</div>
          <div class="item item-rate"><img class="goods-item-img" src="../../../assets/app/good.png" alt=""> </div>
        </div>
        <div class="items">
          <div class="item item-name">{{data.worstTitle}}</div>
          <div class="item item-rate"><img class="goods-item-img" src="../../../assets/app/bad.png" alt=""></div>
        </div>
        <Popup @hide="hidePop" v-if="popObjGoods.visable" :obj="popObjGoods"></Popup>
      </div>
      <div class="places">
        <div class="items">
          <div class="item">{{data.bestAreaName}}</div>
          <div class="item item-rate item-rate-active">{{ data.bestData + "%" }}</div>
        </div>
        <div class="items">
          <div class="item">{{data.worstAreaName}}</div>
          <div class="item item-rate">{{ data.worstData + "%" }}</div>
        </div>
      </div>
    </div>
    <ModelArea :defaultId="areaId" :showModel="showModel" @hide="changeHideModel" @ok="submitModel"></ModelArea>
    <ModelDate :dateValue="dateValue" :isNeedDay="isNeedDay" :showModel="showModelDate" @hide="changeHideModel" @ok="submitDateModel"></ModelDate>
  </div>
</template>
<script>
import Popup from "com/app/common/popup.vue";
import { getUrlParam, formatDateTime } from "libs/common/common";
import { Toast } from "mint-ui";
import { Indicator } from "mint-ui";
import ModelArea from "com/app/add/modelArea.vue";
import ModelDate from "com/app/add/modelDate.vue";
import SelectArea from "com/app/add/selectArea.vue";
import selectDate from "com/app/add/selectDate.vue";

export default {
  components: {
    Popup,
    ModelArea,
    ModelDate,
    SelectArea,
    selectDate
  },
  props: {
    data: {
      type: Object,
      default: {
        thanTitle: "比上月",
        thanTitle2: "比上年",
        bestTitle: "今日最优", //今日最优
        worstTitle: "今日最差", //今日最差
        bestAreaName: "广州", //最优地区
        worstAreaName: "长海", //最差地区
        bestData: "0", //最优数据
        worstData: "0", //最差数据
        family: "0", //新增总用户数
        lastMonth: "0", //上月
        lastYear: "0" //上年
      }
    },
    popObjMouth: {
      type: Object,
      default: {
        title: "", // 也是指标的标题
        ind_unit: "元",
        remark: "",
        top: "0.7rem",
        right: "-0.2rem",
        topRight: "0.15rem",
        visable: false,
        type: 1,
        msg: "今日最优"
      }
    },
    popObjGoods: {
      type: Object,
      default: {
        title: "",
        ind_unit: "元",
        remark: "",
        top: "1.6rem",
        right: "1.4rem",
        topRight: "1.56rem",
        visable: false,
        type: 2,
        msg: ""
      }
    }
  },
  data () {
    return {
      selectDateValue: "", //头部选择的日期
      dateValue: new Date(),
      // 是否展示地区选择 model
      showModel: false,
      // 是否展示日期选择 model
      showModelDate: false,
      // 日期选择 model  是否需要展示 日
      isNeedDay: false,
      // 请求的 id
      areaId: "",
      // 是否收藏
      isStar: false,
      //指标类型
      type: this.$route.query.type ? String(this.$route.query.type).toUpperCase() : "",
      //收藏参数
      collectParams: {
        type: 2, //类型在这个页面固定了是2
        name: "", //收藏的名字，也就是指标的名字
        key: '', //收藏的key，也就是"ms.kpi." 加上指标的 id
        params: '' //指标的 id
      },
      //页面 收藏功能相关用到的 id
      xid: this.$route.query.xid ? this.$route.query.xid : "",
      isFirstTime: false, //是否是第一次进来
    };
  },
  watch: {
    // 日 月 类型的切换, 月的时候 日期选择器不需要展示 日
    tabActiveType (value) {
      if (value == 1) {
        this.isNeedDay = true;
      } else {
        this.isNeedDay = false;
      }
      this.getSelectDate();
    },
    // 当前请求的日期
    activeDate () {
      this.getSelectDate();
    },
    selectDateValue (data) {
      this.$store.commit("SAVE_SHOW_SELECT_DATE_VALUE", {
        showSelectDateValue: data
      });
    },
    collectDate (data) {
      this.collectParams.name = this.collectDate.collectName;
      this.collectParams.params = this.collectDate.collectType;
      this.collectParams.key = "ms.kpi." + this.collectDate.collectType;
      this.isExistedCollect();
    }
  },
  computed: {
    // 用户信息
    userInfo () {
      return this.$store.state.userInfo;
    },
    // 当前请求的日期
    activeDate () {
      return this.$store.state.add.activeDate;
    },
    // 当前选择的地区
    selectArea () {
      return this.$store.state.add.selectArea;
    },
    // 日 月 类型的切换, 月的时候 日期选择器不需要展示 日
    tabActiveType () {
      return this.$store.state.add.tabActiveType;
    },
    // 展示当前请求有数据的最新日期
    showSelectDateValue () {
      return this.$store.state.add.showSelectDateValue;
    },
    //收藏的指标id 类型数据
    collectDate () {
      return this.$store.state.add.collectDate;
    }
  },
  methods: {
    // 选择的日期改变的时候
    getSelectDate () {
      let date = formatDateTime(this.activeDate, "YYYY-MM-DD mm:ss");
      if (this.tabActiveType == 1) {
        this.selectDateValue = date.slice(0, 10);
      } else {
        this.selectDateValue = date.slice(0, 7);
      }
    },
    // 提交 地区
    submitModel (data) {
      this.$store.commit("SAVE_SELECT_AREA", {
        selectArea: data
      });
    },
    // 提交日期
    submitDateModel (date) {
      this.showModelDate = false;
      if (this.tabActiveType == 1) {
        this.selectDateValue = formatDateTime(date, "YYYY-MM-DD mm:ss").slice(0, 10);
      } else {
        this.selectDateValue = formatDateTime(date, "YYYY-MM-DD mm:ss").slice(0, 7);
      }
      this.$store.commit("SAVE_ACTIVE_DATE", {
        activeDate: date
      });
    },
    changeHideModel (type) {
      if (type == 1) {
        this.showModel = false;
      } else {
        this.showModelDate = false;
      }
    },
    changeModel (type) {
      if (type == 1) {
        if (this.userInfo.level < 2) {
          this.showModel = true;
        } else {
          Toast("您的账号权限有限！不可查看其他地区的信息！");
        }
      } else {
        this.showModelDate = true;
      }
    },
    collectFn () {

      // let href = location.href;
      // let index = href.indexOf("?") || 0;
      // this.collectParams.params = href.slice(0, index + 1) + "type=" + this.$route.query.type;
      // this.collectParams.params = 'https://emm.cmccbigdata.com:8443/file/kpi/#/add?type=' + this.$route.query.type
      if (!this.isStar) {
        this.collect();
      } else {
        this.deleteCollect();
      }
    },
    collect () {
      let dt = new FormData();
      dt.append("type", this.collectParams.type);
      dt.append("name", this.collectParams.name);
      dt.append("key", this.collectParams.key);
      dt.append("params", this.collectParams.params);

      Indicator.open();
      this.$http
        .post(this.$urls.save, dt, {
          headers: {
            xid: this.xid
          }
        })
        .then(res => {
          Indicator.close();
          if (res.data.code === 200) {
            this.isStar = true;
            Toast({
              message: "操作成功",
              iconClass: "icon icon-success"
            });
          } else {
            Toast({
              message: "操作失败",
              iconClass: "icon icon-error"
            });
          }
        })
        .catch(error => {
          Indicator.close();
          console.log(error);
        });
    },
    deleteCollect () {
      Indicator.open();
      let dt = new FormData();
      dt.append("key", this.collectParams.key); //收藏的key，也就是"ms.kpi." 加上指标的 id
      this.$http
        .post(this.$urls.delete, dt, {
          headers: {
            xid: this.xid
          }
        })
        .then(res => {
          Indicator.close();
          if (res.data.code === 200) {
            this.isStar = false;
            Toast({
              message: "操作成功",
              iconClass: "icon icon-error"
            });
          }
        })
        .catch(error => {
          Indicator.close();
          console.log(error);
        });
    },
    isExistedCollect () {
      let dt = new FormData();
      dt.append("key", this.collectParams.key); //收藏的key，也就是"ms.kpi." 加上指标的 id
      this.$http
        .post(this.$urls.isExisted, dt, {
          headers: {
            xid: this.xid
          }
        })
        .then(res => {
          if (res.data.code === 200) {
            this.isStar = res.data.data.existed;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    showPopup (type) {
      if (type === 1) {
        this.popObjMouth.visable = true;
      } else {
        this.popObjGoods.visable = true;
      }
    },
    hidePop (type) {
      if (Number(type) === 1) {
        this.popObjMouth.visable = false;
      } else {
        this.popObjGoods.visable = false;
      }
    }
  },
  created () {

  },
  mounted () { }
};
</script>
<style lang="less" scoped>
.font-family-fn(@family) {
  font-family: @family;
}

.header {
  height: 5.12rem;
  padding-top: 0.3rem;
  background-color: #0384df;
  .selects {
    height: 0.8rem;
    font-size: 0.3rem;
    margin-top: 0.2rem;
    .selects-area,
    .selects-date {
      width: 2.8rem;
    }
    .selects-area {
      margin-left: 0.5rem;
    }
    .selects-date {
      margin-right: 1.1rem;
    }
  }
  .mint-header {
    height: 0.8rem;
    background-color: #0384df;
    z-index: 9;
    .mint-header-title {
      font-size: 0.36rem;
      font-weight: normal;
      .font-family-fn('PingFang-SC-Medium');
    }
    .mintui {
      font-size: 0.36rem;
    }
    .star {
      width: 0.45rem;
      margin-right: 0.2rem;
    }
  }
  .stars {
    position: absolute;
    width: 0.45rem;
    top: -0.72rem;
    right: 0.3rem;
  }
  .all {
    width: 100%;
    color: #fff;
    padding-top: 0.5rem;
    text-align: center;
    position: relative;
    font-size: 0.26rem;
    display: flex;
    .all-item-01 {
      flex: 1;
      padding-right: 1rem;
      height: 0.88rem;
    }
    .all-item-02 {
      .font-family-fn('PingFang-SC-Regular');
      font-weight: 300;
      position: absolute;
      right: 0.4rem;
      top: 0.85rem;
      .question {
        position: relative;
        top: 2px;
        width: 0.25rem;
      }
      .mouth {
        font-size: 0.26rem;
      }
    }
    .number {
      font-size: 0.63rem;
      .font-family-fn('PingFang-SC-Heavy');
    }
    .desc {
      font-weight: 300;
      position: absolute;
      font-size: 0.24rem;
      top: 0.88rem;
    }
  }
  .rates {
    font-weight: 300;
    padding-top: 0.3rem;
    color: #fff;
    display: flex;
    margin: 0 0.61rem;
    text-align: center;
    .items {
      font-size: 0.29rem;
      flex: 1;
      display: flex;
      .item {
        .font-family-fn('PingFang-SC-Regular');
        flex: 1;
        .item-img {
          width: 0.1rem;
        }
      }
      .item-rate {
        .font-family-fn('PingFang-SC-Bold');
        text-align: center;
        color: #4cff65;
      }
      .item-rate-active {
        color: #fcc92e;
      }
    }
  }

  .header-bottom {
    position: relative;
    margin: 0.7rem 0.61rem 0 0.61rem;
    background-color: #3296dc;
    height: 1.1rem;
    padding-top: 0.24rem;
    .goods {
      color: #fff;
      display: flex;
      text-align: left;
      .items {
        font-size: 0.31rem;
        flex: 1;
        display: flex;
        padding-left: 0.3rem;
        .item {
          .goods-item-img {
            width: 0.33rem;
          }
        }
        .item-rate {
          padding-left: 0.7rem;
          text-align: center;
          color: #4cff65;
        }
        .item-name {
          .font-family-fn('PingFang-SC-Bold');
        }
      }
      .popups {
        font-size: 0.26rem;
      }
    }
    .places {
      font-weight: 300;
      color: #fff;
      display: flex;
      padding-top: 0.1rem;
      .items {
        font-size: 0.29rem;
        flex: 1;
        display: flex;
        padding-left: 0.3rem;
        .item {
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          width: 1.4rem;
          .item-img {
            width: 0.1rem;
          }
        }
        .item-rate {
          .font-family-fn('PingFang-SC-Bold');
          text-align: center;
          color: #4cff65;
        }
        .item-rate-active {
          color: #fcc92e;
        }
      }
    }
  }
}
.header-area {
  height: 3.6rem;
}
.popup-content {
  padding: 0.2rem;
}

.header .mint-popup {
  border-radius: 0.2rem;
}

.header-line {
  position: absolute;
  top: 0;
  left: 50%;
  height: 1.3rem;
  width: 0.02rem;
  background-color: #3e9ee0;
}
</style>



// WEBPACK FOOTER //
// src/components/app/add/header.vue